"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Stepper = void 0;
const React = __importStar(require("react"));
const StepIcon_1 = require("./StepIcon");
const Stepper_styles_1 = require("./Stepper.styles");
exports.Stepper = ({ isComplete = false, activeStep = 0, onStepIconPress, totalSteps, }) => {
    const onIconPress = (newIndex) => {
        onStepIconPress(newIndex);
    };
    const renderStepIcons = () => {
        const steps = [];
        for (let i = 0; i < totalSteps; i += 1) {
            const isCompletedStep = isComplete ? true : i < activeStep;
            const isActiveStep = isComplete ? false : i === activeStep;
            steps.push(React.createElement(React.Fragment, { key: i },
                React.createElement(StepIcon_1.StepIcon, { stepIndex: i, isLastStep: i === totalSteps - 1, isCompletedStep: isCompletedStep, isActiveStep: isActiveStep, onIconPress: onIconPress })));
        }
        return steps;
    };
    return React.createElement(Stepper_styles_1.StepperContainer, null, renderStepIcons());
};
